import baseConfig, { Config } from "../../utils/config";

// Visual Query - Public Demo configuration
// Inspired by snowflake config, adapted for public-facing demonstrations
const publicDemoConfig: Config = {
  ...baseConfig,
  AppName: "CADViewer Visual Query:",
  initFileName: "",//"/content/custom/ggp/ggp-splash-05.svg",
  ServerBackEndUrl: "https://server.ai.cadviewer.com",
  //ServerBackEndUrl: "http://localhost:3000",
  ServerLocation: "",
  ServerUrl: "https://vqai.cadviewer.com",
  //ServerUrl: "http://localhost:3001",
  debugMode: false, // disabled for public demo
  DisplayCoordinatesMenu: false,
  displayTopNavigationBar: false,
  setSpaceObjectsCustomMenu: false,
  hideLeftHamburgerMenu: false,
  enableDemoNavigation: false,
  BaseAttributes: {
    fill: "#ffd7f4",
    "fill-opacity": 0.0,
    stroke: "#CCC",
    "stroke-width": 0.1,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  HighlightAttributes: {
    fill: "#a4d7f4",
    "fill-opacity": 0.1,
    stroke: "#a4d7f4",
    "stroke-width": 0.2,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  SelectAttributes: {
    fill: "#5BBEF6",
    "fill-opacity": 0.2,
    stroke: "#5BBEF6",
    "stroke-width": 0.23,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  postFixServerToken: true,
  // Locations for property data
  globalApplicationFilesLocation:
    "https://server.ai.cadviewer.com/content/custom/public_demo_presentation/json/application/",
  //  "http://localhost:3000/content/vizquery_nextgen/v26/json/application/",

  propertySVGFilesLocation:
    "https://server.ai.cadviewer.com/content/custom/public_demo_presentation/svg/",
  //  "http://localhost:3000/content/vizquery_nextgen/v26/svg/",

  propertyJSONFilesLocation:
     "https://server.ai.cadviewer.com/content/custom/public_demo_presentation/json/property/",
    //"http://localhost:3000/content/vizquery_nextgen/v26/json/property/",

  // Default property to Load
  defautlPropertyToLoad: {
    propertyNumber: "6482", //"",//"2397",
    planName: "LP1",//"LP1",
    planView: "Base Plan",
  },

  
  enableQuickPdfPrint: true,
  enableAIChat: true,
  enableAIAssistantPictureInPicture: true, // Set to true to enable the Pop Out functionality for the AI Assistant
  useAIChatV5: true,
  useAIChatV4: false,
  chatResultDisplayMetrics: true,
  aiChatV5Endpoint: "https://server.ai.cadviewer.com/ai/proxy",
  aiChatV5Provider: "cadviewer-analytics" as
    | "snowflake"
    | "python"
    | "snowflake-agent"
    | "cadviewer-analytics",
  aiChatV5Mode: "Prod" as "Test" | "Prod",
  propertyJSONFilesEnableDistance: true,
  propertyJSONFilesEnableLayerColors: true,

  // Remote distance query (bay-to-bay lookup over the -distances matrices)
  // Backend endpoint lives on ServerBackEndUrl (server.ai.cadviewer.com)
  enableDistanceQuery: true,
  distanceQueryApiPath: "/api/distance",
  topPaneScrollDownTitle: "Choose information plan/layer:",
  displayTopPaneScrollDownButton: true,
  topRowItem1: "Property Name:",
  topRowItem2: "Property Number:",
  topRowItem3: "Plan Name:",
  enableRightJSONModalPanel: true,
  enableRightFileModalPanel: false,
  setCADViewerSkin: "light-skin",
  setBPLayerChange: true,
  serverSubFolder: "/drawings/dwg/",
  showOnlySubFolder: true,
  showLogoOnSideBarLeftPanel: true,
  cvjs_styleQTip_width: "320px",

  enableHelperMethods: true,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: false,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,

  aiBaseQueries: [
    "Which stores has a future tenant? list current and future tenants",
    "How many malls are in the portfolio, list them with decreasing number of stores, include the state",
    "I need all stores within 110 feet from Lululemon with lease expiration before 2027",
    "Which tenants who are below their average square footage size over all malls by 10% or more and above their average total sales by 10% or more",
    "Find adjacent vacant or expiring spaces within the next 6 months that could be combined",
    "Provide the best options to combine adjacent spaces between 7,000 - 12,000 SF based on total rent and lease expiration",
    "Analyze all lease plans in the portfolio and recommend a prospective tenant for Space 1485 based on the size of the space and frequent co-tenants within 200 feet of the store-front",
  ],
  cadviewerLicenseKey:
    "00110010 00110010 00110000 00110000 00110010 00110000 00110011 00110001 00110101 00110111 00110001 00110101 00111001 00110001 00110101 00110110 00110001 00110011 00111000 00110001 00110101 00110001 00110001 00110101 00110101 00110001 00110011 00110111 00110001 00110101 00110101 00110001 00110100 00110010 00110010 00110001 00110000 00110001 00110101 00110111 00110001 00110100 00110101 00110001 00110100 00110111 00110001 00111001 00110111 00110001 00110100 00111000 00110001 00110100 00110101 00110001 00110101 00110111 00110001 00110101 00111001 00110001 00110100 00111000 00110001 00110101 00110010 00110001 00110100 00110101 00110001 00110100 00110001 00110001 00110100 00110000 00110001 00111001 00111000 00110010 00110000 00110110 00110010 00110000 00111000 00110010 00110000 00110110 00110010 00110000 00110001 00110010 00110001 00110001 00110010 00110000 00111000 00110010 00110000 00110101 00110010 00110001 00110001 00110010 00110000 00110101 00110010 00110000 00110111",
  showTourInformationDialog: false,
  enableHelpButton1: false,
  helpbutton1: "Tech Docs",
  helpbutton1link: "https://cadviewer.com/cadviewertechdocs/",
  enableHelpButton2: false,
  helpbutton2: "User Manual",
  helpbutton2link: "https://cadviewer.com/cadviewerusermanual/",
  customHtmlHeaderContent: `
  `,
  enableLoginFeature: false,
  enableSpaceTools: false,
  enableQuickActions: false,

  // Button Colors Configuration - CADViewer Orange
  buttonColors: {
    primary: {
      bg: "#e8590c",
      bgHover: "#c2410c",
      text: "#ffffff",
      ring: "#e8590c",
    },
    accent: {
      bg: "#f97316",
      bgHover: "#ea580c",
      text: "#ffffff",
      gradientFrom: "#fb923c",
      gradientTo: "#c2410c",
      ring: "#f97316",
    },
    fab: {
      bg: "#e8590c",
      bgHover: "#c2410c",
      text: "#ffffff",
      ring: "#e8590c",
    },
    subtle: {
      bg: "#fed7aa",
      bgHover: "#fdba74",
      text: "#c2410c",
    },
  },

  primaryColors: {
    50: "#fff7ed",
    100: "#ffedd5",
    200: "#fed7aa",
    300: "#fdba74",
    400: "#fb923c",
    500: "#f97316",
    600: "#ea580c",
    700: "#c2410c",
    800: "#9a3412",
    900: "#7c2d12",
  },

  // Theme Colors Configuration
  themeColors: {
    sidebarBackground: "#c2410c",
  },
  omitSpaceObjectLayerHandling: false,
  // Tiled Views - tower overview window opened from the property card
  enableTiledViews: true,
  ShowInformativeBottomPanel: true, // turn the the bottom panel on off
  ShowInformativeBottomPanelWhenClickInLeftPanel: true,
  ShowInformativeLeftPanel: false, // initia show the left side panel
  bottomPaneSliderMode: "aboveCADViewer", // withCADViewer, aboveCADViewer,
  bottomPaneDefaultHeight: 15, // (15)   percentage of screen height (2) min
  rightPanelDefaultWidth: 36, // (40) percentage of screen height
  leftPaneDefaultWidth: 17, // (17) percentage of screen height

};

export default publicDemoConfig;
